import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgEmail = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="m19.534 4.874-3.505.309-3.695-2.312L7.43 5.934l-3.15.28.147 1.604-1.517.943v10.012h18.847V8.76l-1.988-1.237-.235-2.65Zm-7.2-1.31 2.723 1.707-6.33.545 3.607-2.253Zm6.67 1.943.397 4.505-1.767.942-9.1.796-3.327-1.767-.28-3.24 14.076-1.236Zm-2.71 6.154-2.856 1.517h-2.209l-1.737-.928 6.802-.589ZM4.486 8.466l.103 1.178-1.075-.574.972-.604Zm-.987 1.281 7.112 3.77-7.112 4.373V9.747Zm.648 8.437 7.185-4.417h2.017l7.186 4.417H4.147Zm17.02-.294-7.11-4.373 7.11-3.77v8.143Zm-.014-8.805-1.192.633-.133-1.458 1.325.825Z"
        fill="#374151"
      />
      <path
        d="m12.71 7.842-5.867.513.051.587 5.867-.513-.051-.587ZM17.544 9.183l-10.56.924.05.587 10.562-.924-.052-.587Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgEmail;
